import React from "react";
import { SpinnerCustom } from "../ui/Spinner";

/**
 * Full-area loading overlay (month change / refetch while stale data visible).
 */
const Report20DataLoadingOverlay = ({ show, message = "Loading report data…" }) => {
  if (!show) return null;
  return (
    <div
      className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-3 rounded-2xl bg-white/80 backdrop-blur-[2px] border border-slate-200/60 shadow-sm"
      aria-busy="true"
      aria-live="polite"
    >
      <SpinnerCustom />
      <p className="text-sm font-medium text-slate-600">{message}</p>
    </div>
  );
};

export default Report20DataLoadingOverlay;
